"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetQuoteButton = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../shared/core");
var analytics_subjects_1 = require("../analytics-subjects");
function GetQuoteButton(_a) {
    var _b;
    var children = _a.children;
    var PrimaryCTALink = (0, core_1.useComponents)().PrimaryCTALink;
    var quoteAndSwitch = (0, core_1.useLinks)().quoteAndSwitch;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.MOVE_OUT_GET_QUOTE, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(PrimaryCTALink, { href: quoteAndSwitch(), opensInNewWindow: true }, children)));
}
exports.GetQuoteButton = GetQuoteButton;
